/* globals document */
import React from 'react';
import ReactDOM from 'react-dom';
import {HelmetProvider} from 'react-helmet-async';
import {Provider} from 'react-redux';
import {Router} from 'react-router-dom';
import {ConnectedRouter} from 'connected-react-router';
import {PersistGate} from 'redux-persist/integration/react';
import Modal from 'react-modal';
import {I18nextProvider} from 'react-i18next';
import {registerStore, setupRequest} from 'core/helpers/request';
import Routes from './Routes';
import {store, persistor, history} from './store/store';
import UtilHelper from './utils/utils-helper';
import {i18next, setLocale} from './services/i18nHandler';
import {client} from '../config/env/all';
import './assets/less/main.less';

UtilHelper.setAppVersion();
Modal.setAppElement('#root');

// Register store for request
registerStore(store);
// Setup request
global.request = setupRequest({
  basicAuthorization: `Basic ${Buffer.from(`${client.clientId}:${client.clientSecret}`).toString('base64')}`,
  clientAuthorization: {client_id: client.clientId, client_secret: client.clientSecret},
});

const helmetContext = {};

const language = localStorage.getItem('language') || document.documentElement.lang;
setLocale(language);

ReactDOM.render(
  <I18nextProvider i18n={i18next}>
    <HelmetProvider context={helmetContext}>
      <Provider store={store}>
        <PersistGate loading={null} persistor={persistor}>
          <ConnectedRouter history={history}>
            <Router history={history} store={store}>
              <Routes history={history} store={store} />
            </Router>
          </ConnectedRouter>
        </PersistGate>
      </Provider>
    </HelmetProvider>
  </I18nextProvider>,
  document.getElementById('root'),
);

// Hot-reloading
if (module.hot) {
  module.hot.accept();
}
